<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Banner from "./components/banner/";
import Main from "./components/main";

export default {
  name: "App",
  components: {
    Banner,
    Main,
  },
};
</script>

<style scoped>
.effect1 {
  position: absolute;
  top: 190px;
}

.effect2 {
  width: 650px;
  height: 600px;
  position: absolute;
  top: 0;
  z-index: -1;
}
img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>

<style>
.effect {
  width: 600px;
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  z-index: -1;
}
html,
body {
  margin: 0;
}
.outter {
  background-image: url(@/assets/background.jpg);
  background-size: 100% 100%;
}

* {
  font-family: "微软雅黑", sans-serif;
}
#dv-full-screen-container {
  position: unset !important;
}
</style>
